module.exports = __webpack_public_path__ + "static/media/wide.850cf59b.jpg";